/*
 * gw-bogo-qty.js — makes the Buy-1-Get-1 pages add two pairs instead of one.
 *
 * The problem it fixes: a BOGO product is priced per unit at the two-pair price (Ramblers
 * BOGO is $159.99, the single is $104.99) and the free pair comes from an automatic Bxgy
 * discount that only fires at quantity 2. The add-to-cart form has no quantity field at all,
 * so it posts quantity=1 — and a buyer who does not read the banner pays the two-pair price
 * for one pair. This appends a hidden quantity=2 and relabels the button.
 *
 * Only touches products whose title matches "buy 1, get 1". Runs after gw-hike.js, which
 * rewrites the button label itself, so the label is re-applied through an observer.
 */
(function () {
  var LABEL = 'Add 2 pairs — 2nd free';

  function title() {
    var t = document.querySelector('.product-main__title');
    return t ? t.textContent : document.title;
  }

  function isBogo() {
    return document.body.classList.contains('template-product') && /buy 1,?\s*get 1/i.test(title());
  }

  function form() {
    return document.querySelector('.product-main__form') || document.querySelector('form[action*="/cart/add"]');
  }

  function setQty() {
    var f = form();
    if (!f) return;
    var q = f.querySelector('[name="quantity"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      f.appendChild(q);
    }
    if (q.value !== '2') q.value = '2';
  }

  function setLabel() {
    var lbl = document.querySelector('.gw-atc__lbl');
    if (lbl && lbl.textContent.trim() !== LABEL) lbl.textContent = LABEL;
  }

  function run() {
    if (!isBogo()) return;
    setQty();
    setLabel();
    var atc = document.querySelector('.gw-atc, .product-main__form button[type=submit]');
    if (atc) atc.addEventListener('click', setQty, true);
    new MutationObserver(function () { setQty(); setLabel(); })
      .observe(document.body, { childList: true, subtree: true });
  }

  function boot() { setTimeout(run, 600); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
